import React from 'react'
import algoliasearch from 'algoliasearch/lite'
import { useSelector, useDispatch } from 'react-redux'
import { InstantSearch, SearchBox, Configure, connectStats } from 'react-instantsearch-dom'

import Layout from '../components/layout'
import Seo from '../components/seo'
import CustomHits from '../components/search/hits'
import CustomPagination from '../components/search/pagination'
import SearchActions from '../components/search/searchActions'

import trads from '../intl/trads.json'
import { saveSearchState } from '../store/actions'

const searchClient = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY_SEARCH)

// main search page
const Search = ({data, pageContext, location}) => {
  const dispatch = useDispatch()
  const lang = useSelector(state => state.lang)
  const savedSearchState = useSelector(state => state.savedSearchState)

  const currentSearchQuery = useSelector(state => state.currentSearchQuery)
  const currentSearchFilters = useSelector(state => state.currentSearchFilters)

  let filters = null
  let searchQuery = null

  if (location.state) {
    filters = location.state.filters
    searchQuery = location.state.searchQuery
  } 
  
  if (currentSearchQuery) {
    searchQuery = currentSearchQuery
  }
  
  if (currentSearchFilters) {
    filters = currentSearchFilters
  }

  const urlsParameters = location.search.substring(1).split('&')

  if (urlsParameters && searchQuery === null) {
    urlsParameters.forEach(param => {
      param = param.split('=')

      if(param[0] === 'q') {
        searchQuery = param[1]
      }
    })
  } else {
    if(typeof window !== 'undefined') {
      let queryParams = new URLSearchParams(window.location.search)
      queryParams.set("q", searchQuery)
      
      /* eslint-disable */
      history.replaceState(null, null, "?"+queryParams.toString())
      /* eslint-enable */
    }
  }

  return (
    <>
      <Layout 
        frUrl="/recherche"
        enUrl="/en/search"
        initLocale={pageContext.locale}
        mainTag="search"
        headerType="bg-white"
      >
        <Seo
          frUrl="/recherche"
          enUrl="/en/search"
          noIndex={true}
          page={{
            title: lang === 'fr' ? 'Recherche' : 'Search',
          }}
        />

        <div className="search-page pt-8 md:pt-12 search-container-wrapper">
          <InstantSearch 
            searchClient={searchClient} 
            indexName={process.env.GATSBY_ALGOLIA_INDEX}
            onSearchStateChange={searchState => {
              dispatch(saveSearchState(searchState))
            }}
            searchState={savedSearchState}>
            <Configure 
              hitsPerPage={10}
              filters={`node_locale:${lang}`}
              />

            <div className="row items-center">
              <div className="col-12 lg-col-3">
                <h1 className="title title-slice title title-slice--big mb-6 lg:mb-0">{trads[lang].search.results}</h1>
              </div>
              <div className="col-12 lg-col-8 lg-col-offset-1">
                <SearchBox
                  onInput={event => {
                    if (event.currentTarget.value.length > 0) {
                      event.currentTarget.closest('.ais-SearchBox').classList.add('has-clear')
                    } else {
                      event.currentTarget.closest('.ais-SearchBox').classList.remove('has-clear')
                    }
                  }}
                  onReset={event => {
                    event.currentTarget.closest('.ais-SearchBox').classList.remove('has-clear')
                  }}
                  defaultRefinement={searchQuery}
                  translations={{ placeholder: trads[lang].search.searchPlaceholder}} />
              </div>
            </div>

            <div className="row mt-10 md:mt-18">
              <div className="col-12 lg-col-3 lg:pt-12">
                <SearchActions
                  currentFilters={filters} />
              </div>

              <div className="col-12 lg-col-8 lg-col-offset-1 search-actions-content">
                <CustomStats lang={lang} />
                <CustomHits />
                <CustomPagination />
              </div>
            </div>
          </InstantSearch>
        </div>
      </Layout>
    </>
  );
}

// custom stats
const Stats = ({ processingTimeMS, nbHits, lang }) => (
  <p className="search-page__results">
    {nbHits} {(nbHits > 1) ? trads[lang].search.results : trads[lang].search.result}
  </p>
)

const CustomStats = connectStats(Stats)

export default Search